export const allVehicleSortingOptions = (t: Function) => [
  // 『既定』はサーバーの既定の並び（新しい順）。vehicles に check_in は無い。
  { label: t('sort.default', { ns: 'common' }), value: '' },
  { label: t('sort.plate-number', { ns: 'common' }), value: 'plate_number' },
];

export const addVehicleFields = (t: Function, data: any = {}) => [
  {
    label: t('all-vehicle.add-vehicle.plate-number', { ns: 'vehicle' }),
    type: 'text',
    name: 'plate_number',
    isRequired: true,
  },
  {
    label: t('all-vehicle.add-vehicle.truck-model', { ns: 'vehicle' }),
    type: 'text',
    name: 'car_model',
    isRequired: true,
  },
];

export const editVehicleFields = (t: Function, data: any = {}) => [
  {
    label: t('all-vehicle.edit-vehicle.plate-number', { ns: 'vehicle' }),
    type: 'text',
    name: 'plate_number',
    isRequired: true,
    value: data.plate_number,
  },
  {
    label: t('all-vehicle.edit-vehicle.truck-model', { ns: 'vehicle' }),
    type: 'text',
    name: 'car_model',
    isRequired: true,
    value: data.car_model,
  },
];

export const deleteVehicleFields = (t: Function, data: any = {}) => [
  {
    label: t('all-vehicle.delete-vehicle.plate-number', { ns: 'vehicle' }),
    name: 'plate_number',
    value: data.plate_number,
  },
  {
    label: t('all-vehicle.delete-vehicle.truck-model', { ns: 'vehicle' }),
    name: 'car_model',
    value: data.car_model,
  },
];
